import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _cancelScheduleRequest = {};
var _cancelScheduleResponse = { schedule: '_schedule' };
var _cloneScheduleRequest = {
    fieldmask: 'google.protobuf.FieldMask',
    schedule: '_schedule',
};
var _cloneScheduleResponse = { schedule: '_schedule' };
var _createScheduleRequest = { schedule: '_schedule' };
var _createScheduleResponse = { schedule: '_schedule' };
var _getScheduleRequest = {};
var _getScheduleResponse = { schedule: '_schedule' };
var _querySchedulesRequest = {};
var _querySchedulesResponse = { schedules: '_schedule' };
var _schedule = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _updateScheduleRequest = {
    fieldmask: 'google.protobuf.FieldMask',
    schedule: '_schedule',
};
var _updateScheduleResponse = { schedule: '_schedule' };
function resolveWixCalendarSchedulesV3SchedulesServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/schedules-3',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/calendar/v3/schedules',
                destPath: '/v3/schedules',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/calendar/v3/schedules',
                destPath: '/v3/schedules',
            },
        ],
        _: [
            {
                srcPath: '/_api/calendar/v3/schedules',
                destPath: '/v3/schedules',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/calendar/v3/schedules',
                destPath: '/v3/schedules',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves a schedule by ID. */
export function getSchedule(payload) {
    var _a = serializer(_getScheduleRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getScheduleResponse, { _schedule: _schedule }).fromJSON;
    function __getSchedule(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.schedule',
            method: 'GET',
            methodFqn: 'wix.calendar.schedules.v3.SchedulesService.GetSchedule',
            url: resolveWixCalendarSchedulesV3SchedulesServiceUrl({
                protoPath: '/v3/schedules/{scheduleId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSchedule.fromReq = fromReq;
    __getSchedule.__isAmbassador = true;
    return __getSchedule;
}
/**
 * Query for schedules given the provided filters and paging.
 *
 * By default only active schedules are returned, unless a `status` filter is provided.
 */
export function querySchedules(payload) {
    var _a = serializer(_querySchedulesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_querySchedulesResponse, {
        _schedule: _schedule,
    }).fromJSON;
    function __querySchedules(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.schedule',
            method: 'POST',
            methodFqn: 'wix.calendar.schedules.v3.SchedulesService.QuerySchedules',
            url: resolveWixCalendarSchedulesV3SchedulesServiceUrl({
                protoPath: '/v3/schedules/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __querySchedules.fromReq = fromReq;
    __querySchedules.__isAmbassador = true;
    return __querySchedules;
}
/** Creates a schedule. */
export function createSchedule(payload) {
    var _a = serializer(_createScheduleRequest, { _schedule: _schedule }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createScheduleResponse, {
        _schedule: _schedule,
    }).fromJSON;
    function __createSchedule(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.schedule',
            method: 'POST',
            methodFqn: 'wix.calendar.schedules.v3.SchedulesService.CreateSchedule',
            url: resolveWixCalendarSchedulesV3SchedulesServiceUrl({
                protoPath: '/v3/schedules',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createSchedule.fromReq = fromReq;
    __createSchedule.__isAmbassador = true;
    return __createSchedule;
}
/** Updates a schedule. */
export function updateSchedule(payload) {
    var _a = serializer(_updateScheduleRequest, { _schedule: _schedule }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateScheduleResponse, {
        _schedule: _schedule,
    }).fromJSON;
    function __updateSchedule(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.schedule',
            method: 'PATCH',
            methodFqn: 'wix.calendar.schedules.v3.SchedulesService.UpdateSchedule',
            url: resolveWixCalendarSchedulesV3SchedulesServiceUrl({
                protoPath: '/v3/schedules/{schedule.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateSchedule.fromReq = fromReq;
    __updateSchedule.__isAmbassador = true;
    return __updateSchedule;
}
/** Clone a schedule. */
export function cloneSchedule(payload) {
    var _a = serializer(_cloneScheduleRequest, { _schedule: _schedule }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cloneScheduleResponse, {
        _schedule: _schedule,
    }).fromJSON;
    function __cloneSchedule(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.schedule',
            method: 'POST',
            methodFqn: 'wix.calendar.schedules.v3.SchedulesService.CloneSchedule',
            url: resolveWixCalendarSchedulesV3SchedulesServiceUrl({
                protoPath: '/v3/schedules/{scheduleId}/clone',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cloneSchedule.fromReq = fromReq;
    __cloneSchedule.__isAmbassador = true;
    return __cloneSchedule;
}
/** Cancels a schedule. */
export function cancelSchedule(payload) {
    var _a = serializer(_cancelScheduleRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelScheduleResponse, {
        _schedule: _schedule,
    }).fromJSON;
    function __cancelSchedule(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.schedule',
            method: 'POST',
            methodFqn: 'wix.calendar.schedules.v3.SchedulesService.CancelSchedule',
            url: resolveWixCalendarSchedulesV3SchedulesServiceUrl({
                protoPath: '/v3/schedules/{scheduleId}/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cancelSchedule.fromReq = fromReq;
    __cancelSchedule.__isAmbassador = true;
    return __cancelSchedule;
}
//# sourceMappingURL=http.impl.js.map